import React, { Component } from 'react';
import axios from "axios";
import InputMask from 'react-input-mask';
import { Input, Row, Col, FormFeedback, Label, Card, CardHeader, CardColumns, CardBody } from 'reactstrap';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from "react-chartjs-2";

import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';



import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import api from '../../api/';
import auth from '../../auth/';
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import DetailSolicitud from '../Proyectos/Procedimiento1/Detail.js';
import DetailPlanDeTrabajo from '../Proyectos/Procedimiento2/Detail.js';
import DetailPresupuesto from '../Proyectos/Procedimiento3/Detail.js';

class Estadisticas extends Component {
    constructor() {
        super();
        this.state = {
            proyecto_nombre: "",
            proyecto_data: null,
            proyecto_codigo: "",
            departamento_list: {
                labels: [],
                datasets: []
            },
            year_list: {
                labels: [],
                datasets: []
            },
            empresa_list: {
                labels: [],
                datasets: []
            },
            month_list: {
                labels: [],
                datasets: []
            },
            departamento: -1,
            empresa: -1,
            year: -1,
            first: true,
        };
    }

    UpdateFilters(departamento, empresa, year) {
        var url = api.proyectos.solicitudes.estadisticas + "?";
        url += "departamento_id=" + departamento;
        url += "&empresa_id=" + empresa;
        url += "&year=" + year;

        axios.get(url, auth.header())
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        departamento_list: response.data.departamento,
                        empresa_list: response.data.empresa,
                        year_list: response.data.year,
                        month_list: response.data.month,
                    });
                }
            });
    }

    ChangedDepartamento(data) {
        if (data != null) {
            this.setState({ departamento: data.pk });
            this.UpdateFilters(data.pk, this.state.empresa, this.state.year);
        }
        else {
            this.setState({ departamento: -1 });
            this.UpdateFilters(-1, this.state.empresa, this.state.year);
        }
    }
    ChangedEmpresa(data) {
        if (data != null) {
            this.setState({ empresa: data.pk });
            this.UpdateFilters(this.state.departamento, data.pk, this.state.year);
        }
        else {
            this.setState({ empresa: -1 });
            this.UpdateFilters(this.state.departamento, -1, this.state.year);
        }
    }
    ChangedYear(data) {
        if (data != "" && data != undefined && data != null) {
            var year = new Date(data._d).getFullYear();
            this.setState({ year: year });
            this.UpdateFilters(this.state.departamento, this.state.empresa, year);
        } else {
            this.setState({ year: -1 });
            this.UpdateFilters(this.state.departamento, this.state.empresa, -1);
        }
    }

    parseDate(stringdate) {
        var date = new Date(stringdate);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var mins = date.getMinutes();

        if (month < 10)
            month = "0" + month;
        if (day < 10)
            day = "0" + day;
        if (hour < 10)
            hour = "0" + hour;
        if (mins < 10)
            mins = "0" + mins;

        return day + "/" + month + "/" + year + " " + hour + ":" + mins;
    }

    render() {
        if (this.state.first) {
            this.setState({ first: false });
            this.UpdateFilters(this.state.departamento, this.state.empresa, this.state.year);
        }
        return (
            <div>
                <div className="row mt-1">
                    <div className="col-12 col-md-2 px-0 px-md-1 pl-md-0">
                        <Label className=" display-inline-block">Año</Label>
                        <Datetime
                            className="display-inline-block"
                            dateFormat="YYYY"
                            closeOnSelect={true}
                            onChange={(data) => this.ChangedYear(data)}
                        />
                    </div>
                    <div className="col-12 col-md-3 px-0 px-md-1">
                        <Label className=" display-inline-block">Grupo</Label>
                        <ParadigmaAsyncSeeker fieldName="" onChange={(data) => this.setState({ grupo_id: (data ? data.pk : null) })}
                            url={api.usuarios.grupos.select} value={this.state.grupo_id} />
                    </div>
                    <div className="col-12 col-md-3 px-0 px-md-1">
                        <Label className=" display-inline-block">Subgrupo</Label>
                        <ParadigmaAsyncSeeker disabled={!this.state.grupo_id}
                            fieldName="" onChange={(data) => this.ChangedDepartamento(data)}
                            url={api.usuarios.subgrupos.select + (this.state.grupo_id ? "?grupo=" + this.state.grupo_id : "")}
                            value={this.state.departamento} />
                    </div>
                    <div className="col-12 col-md-3 px-0 px-md-1">
                        <Label className=" display-inline-block">Empresa</Label>
                        <ParadigmaAsyncSeeker fieldName="" onChange={(data) => this.ChangedEmpresa(data)}
                            url={api.clientes.empresas.select} value={this.state.empresa} />
                    </div>
                </div>
                <div className="row animated fadeIn mt-1">
                    <CardColumns className="cols-2 w-100">
                        <Card>
                            <CardHeader>
                                Proyectos por Departamento
                        </CardHeader>
                            <CardBody className="card-body">
                                <div className="chart-wrapper">
                                    <Bar data={this.state.departamento_list}
                                        options={{
                                            maintainAspectRatio: false,
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        beginAtZero: true,
                                                        scaleBeginAtZero: true,
                                                    }
                                                }]
                                            }
                                        }}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader>
                                Proyectos por Empresa
                        </CardHeader>
                            <CardBody className="card-body">
                                <div className="chart-wrapper">
                                    <Bar data={this.state.empresa_list}
                                        options={{
                                            maintainAspectRatio: false,
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        beginAtZero: true,
                                                        scaleBeginAtZero: true,
                                                    }
                                                }]
                                            }
                                        }}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader>
                                Proyectos por Año
                        </CardHeader>
                            <CardBody className="card-body">
                                <div className="chart-wrapper">
                                    <Bar data={this.state.year_list}
                                        options={{
                                            maintainAspectRatio: false,
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        beginAtZero: true,
                                                        scaleBeginAtZero: true,
                                                    }
                                                }]
                                            }
                                        }}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardHeader>
                                Proyectos por Mes
                        </CardHeader>
                            <CardBody>
                                <div className="chart-wrapper">
                                    <Bar data={this.state.month_list}
                                        options={{
                                            maintainAspectRatio: false,
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        beginAtZero: true,
                                                        scaleBeginAtZero: true,
                                                    }
                                                }]
                                            }
                                        }}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </CardColumns>
                </div>
            </div>
        );
    }
}

export default Estadisticas;



// WEBPACK FOOTER //
// ./src/views/Reportes/Estadisticas.js